import {
  useQuery, UseQueryResult,
} from '@tanstack/react-query';
import { getAlertsAggregation } from '../../services/AlertsService';
import { AlertsAggregationResponse } from '../../types/Alerts';
import { FeaturesManagement } from '../../../featuresControl';

function useGetAlertsAggregation(fleetId: string, query: string, enabled = true): UseQueryResult<AlertsAggregationResponse> {
  return useQuery(
    ['alerts', fleetId, query],
    async (): Promise<AlertsAggregationResponse> => getAlertsAggregation(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      keepPreviousData: true,
      enabled: !!enabled,
    },
  );
}

export default useGetAlertsAggregation;
